module.exports = __webpack_public_path__ + "static/1-9ee43ed95dfa20a1c5be0eff70e046fe.png";